export default __webpack_public_path__ + "static/media/logo-aetna.be89be3b.svg";